module.exports = __webpack_public_path__ + "static/media/Whatsapp-purple.2170f3aa.svg";